import io from 'socket.io-client'
import * as actionTypes from '../../server/constants/action_types'

// If not using django dev server, then set the port to the server port.
const socket = io(`${window.location.protocol}//${window.location.hostname}:${window.location.port < 8000 ? window.location.port : 80}`, { path: '/websockets' })
export const init = (store, handler) => {
    const messageTypes = [actionTypes.WS_CLIENT_ACTION, actionTypes.WS_JOIN_ROOM, actionTypes.WS_LEAVE_ROOM]
    messageTypes.forEach(type => socket.on(type, payload => handler(type, payload)))
}
export const emit = (type, payload) => socket.emit(type, payload)
